import { Grid, Typography } from '@mui/material';
import { getRowIcon } from 'utils/helpers/fileCabinetHelpers';
import { convertBytes } from 'utils/helpers';
import { styles } from './styles';

export const Header = ({
  mimeType,
  size,
  name,
}: {
  mimeType: string;
  size: string;
  name: string;
}) => {
  const Icon = getRowIcon('file', mimeType);

  return (
    <Grid sx={styles.header}>
      <Grid sx={styles.headerInfoWrapper}>
        <Icon width={36} height={36} />
        <Grid sx={styles.headerTextWrapper}>
          <Typography sx={styles.name}>{name}</Typography>
          {size && <Typography sx={styles.size}>{convertBytes(Number(size), 2)}</Typography>}
        </Grid>
      </Grid>
    </Grid>
  );
};
